import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromApp from "../reducers/app.reducer";

export const selectAppState = createFeatureSelector<fromApp.State>(
  fromApp.appFeatureKey
);

export const selectInProgressRequests = createSelector(
  selectAppState,
  (state) => state.inProgressRequests
);

export const selectCurrentModal = createSelector(
  selectAppState,
  (state) => state.modais[0] || null
);

export const selectNfeBudget = createSelector(
  selectAppState,
  (state) => state.selectedBudget
);

export const selectItemToEdit = createSelector(
  selectAppState,
  (state) => state.selectedItem
);

export const selectNfePayload = createSelector(
  selectAppState,
  (state) => state.lastNfeData
);

export const selectSelectedServices = createSelector(
  selectAppState,
  (state) => state.selectedServices
);
